/**
  Add an element to an array in sorted position
  @param  {JSON}    element  Element to be inserted
  @param  {[JSON]}  dataset  Sorted array of elements to be inserted into
  @param  {String}  key      The key in the JSON element to filter on
  @returns  {[JSON]}  Dataset with element inserted in proper locaiton
*/
async function sortedInsert(element, dataset, key)
{
  dataset.splice(locationOf(element, dataset, key) + 1, 0, element);
  return dataset;
}

async function locationOf(element, dataset, key, start, end)
{
  start = start || 0;
  end = end || dataset.length;
  var pivot = parseInt(start + (end - start) / 2, 10);
  if (end - start <= 1 || dataset[pivot][key] === element[key])
  {
    return pivot;
  }
  if (dataset[pivot][key] < element[key])
  {
    return locationOf(element, dataset, key, pivot, end);
  }
  else
  {
    return locationOf(element, dataset, key, start, pivot);
  }
}

let DataModifier =
{
  sortedInsert: sortedInsert
};
export default DataModifier;
